import React, { useContext } from 'react';
import { IColumnDef } from '../../../../../../Types/ColumnDefType';
import { IUIUrval } from '../../../../../../Types/UrvalTypes';
import { ICollectionDataType } from '../Queries/BusinessCollectionQuery';
import { InternalError } from '../../../../../../Components/InternalError/InternalError';
import {
  IClientAssociationModel,
  IClientBusinessModel,
} from '../../../../../../Types/ClientModelTypes';
import {
  findBusinessconfig,
  IBusinessListIconDef,
  findBusinessColors,
  IBusinessColorConfig,
  filterBusinessColors,
  findBusinessStyleConfig,
  IBusinessStylesConfig,
} from '../../../Const/BusinessConfigs';
import { ISortInfo } from '../../../../../../BaseComponents/Table/Components/SortableTableUtils';
import { VisningsTypContext } from '../VisningsTypContext/VisningsTypContext';
import { useItemFunctionMenuItemsType } from '../../../../../../Utils/ObjektVyUtils';
import { TSelectedDetail } from '../../../../../../Types/MasterDetailTypes';
import { visningstyper } from './Visningstyper';
import { ISumColumn } from '../AssociationList/AssociationList';
import BusinessDataSetContext from '../BusinessDataSetContext/BusinessDataSetContext';
import { GridCellParams, GridEventListener } from '@mui/x-data-grid-pro';
import { SelectNewDetailType } from '../../../../_StandardRutin/StandardRutin';
import { useIsFloatingMenuVisible } from '../../../../../../Components/FloatingBottomArea/FloatingMenu';

export type TVisningstyp =
  | 'expanderbar lista'
  | 'lista'
  | 'tabell'
  | 'kort'
  | 'MuiXTabell'
  | 'kalender'
  | 'bisattningStart'
  | 'planering';

export interface IBusinessDataProps {
  columns: readonly IColumnDef[];
  setColumns?: ((columns: readonly IColumnDef[]) => void) | null;
  urval: IUIUrval | null;
  urvalId?: string;
  setUrval?: (newUrval: IUIUrval) => void;
  refetch: () => void;
  loading: boolean;
  selectedId: TSelectedDetail;
  selectDetail?: (id: TSelectedDetail, force?: boolean) => void;
  selectNewDetail: SelectNewDetailType;
  inlineDetail: React.ReactNode;
  selected: string[];
  toggleSelected: (column?: string) => void;
  // Temp until implementation is decided upon
  showCheckboxes?: boolean;
  collection: IClientBusinessModel;
  association?: IClientAssociationModel;
  associationPath?: string;
  sortedData: ISortInfo<ICollectionDataType>;
  newItems?: ICollectionDataType[] | undefined;
  updateSortOrder: (info: ISortInfo<ICollectionDataType>) => void;
  /** Listan visas i ett kort i en detaljvy */
  inCard?: boolean;
  useFunktionsMenyItems?: useItemFunctionMenuItemsType;
  hideDefaultFunktionsMenyItems?: boolean;
  disabled?: boolean;
  useMaterialTable?: boolean;
  doNotUseFunktionsMeny?: boolean;
  onDeleteItem?: (item: ICollectionDataType) => void;
  onRowClick?: GridEventListener<'rowClick'>;
  selectionGrid?: boolean;
  isMiniCard?: boolean;
  editable?: boolean;
  sumColumns?: ISumColumn[];
  isCellDisabled?: (params: GridCellParams<any, any, any>) => boolean;
  /** id som inställningar som t.ex. aktuell kolumnbredd sparas under */
  settingsId: string;
  /** Sätt höjden för att alla rader ska få plats */
  autoHeight?: boolean;
}

export interface IExtendedBusinessDataProps extends IBusinessDataProps {
  businessIcons: IBusinessListIconDef[];
  colors: IBusinessColorConfig[];
  collectionStylesConfig?: IBusinessStylesConfig;
  /** Extra bottom spacing to clear the floating menu when floating menu is visible */
  floatingMenuBottomSpacing?: boolean;
}

/**
 * Visar en lista av associerade objekt
 */
const BusinessDataSet = (props: IBusinessDataProps) => {
  const floatingMenuVisible = useIsFloatingMenuVisible();
  const { visningsTyp } = useContext(VisningsTypContext);
  const businessConfig = findBusinessconfig(props.collection.CollectionName);
  const businessIcons = businessConfig?.listIcons
    ? businessConfig.listIcons
    : [];
  const collectionColors = findBusinessColors(props.collection.CollectionName);
  const collectionStylesConfig = findBusinessStyleConfig(
    props.collection.CollectionName
  );
  const hideColors =
    !!businessConfig?.attributeWithColors &&
    props.columns.findIndex(
      col => col.attributeDef === businessConfig.attributeWithColors
    ) !== -1;
  const colors = hideColors
    ? []
    : filterBusinessColors(collectionColors, props.sortedData);
  const BusinessDataComponent = visningstyper.find(
    typ => typ.id === visningsTyp
  )?.component;
  if (BusinessDataComponent) {
    return (
      <BusinessDataSetContext.Provider
        value={{
          refetch: props.refetch,
          selectNewDetail: props.selectNewDetail,
        }}
      >
        <BusinessDataComponent
          businessIcons={businessIcons}
          colors={colors}
          collectionStylesConfig={collectionStylesConfig}
          floatingMenuBottomSpacing={floatingMenuVisible && !props.inCard}
          {...props}
        />
      </BusinessDataSetContext.Provider>
    );
  }
  return (
    <InternalError
      id="4e46abfc-6afa-4d10-823c-7ea244147386"
      message={`okänd visningsTyp ${visningsTyp}`}
    />
  );
};

export default BusinessDataSet;
